import { render, staticRenderFns } from "./Editvehiculo.vue?vue&type=template&id=1065bc83&"
import script from "./Editvehiculo.vue?vue&type=script&lang=js&"
export * from "./Editvehiculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports